/** @format */

import React, {useState, useEffect, useMemo, useCallback} from "react";
import BarChartCommodities from "./BarChartCommoditites";
import CocoaCommodities from "./CocoaCommodities";
import { TabMenu } from "primereact/tabmenu";
import { Route, Routes, useNavigate, Navigate, useLocation } from "react-router-dom";

function Commodities(props) {
  const { isCocoaRole, isSuperAdminRole } = props;
  let navigate = useNavigate();
  let location = useLocation();
  let menuItems = useMemo(
    () => {
      let barchartConfig = {
        label: "BarChart Commodities",
        path: "barchart",
        command: function () {
          navigate(this.path);
        },
      };
      let cocoaConfig = {
        label: "Cocoa(CRA) Commodities",
        path: "cocoa",
        command: function () {
          navigate(this.path);
        },
      }
      if (isSuperAdminRole || isCocoaRole) {
        return [barchartConfig, cocoaConfig]
      }
      return [barchartConfig]
    },
    [navigate, isSuperAdminRole, isCocoaRole]
  );
  let { pathname } = location;
  let [selectedMenuItem, setSelectedMenuItem] = useState(menuItems[0]);

  useEffect(() => {
    setSelectedMenuItem((prevMenuItems) => menuItems.findIndex((menuItem) => {
      let splitPath = pathname.split("/")
      let __pathname = splitPath[splitPath.length -1]
      return __pathname.includes(menuItem.path);
    }));
  }, [pathname, menuItems]);
    const onTabChangeHandler = useCallback(
      (e) => {
        setSelectedMenuItem(e.index);
      },
      [setSelectedMenuItem]
    );
  return (
    <div style={{ marginTop: "1.5rem" }}>
      <TabMenu
            model={menuItems}
            activeIndex={selectedMenuItem}
            id='mi__tab__menu'
            className='mb-2'
            onTabChange={onTabChangeHandler}
          />
      <Routes>
        <Route path="barchart" element={<BarChartCommodities />}></Route>
        <Route path="cocoa" element={isSuperAdminRole || isCocoaRole ? <CocoaCommodities /> : <Navigate to='barchart' replace />}></Route>
        <Route path='*' element={<Navigate to='barchart' replace />} />
      </Routes>
    </div>
  );
}

export default Commodities;
